import { modalStyles } from '@/components/Modal/Modal.styles';

export const profileStatusDcrControlStyles = {
	headerDivider: [modalStyles.edgeDivider, { mb: 2 }],

	bodyText: {
		color: 'text.secondary'
	},

	footerRoot: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 2,
		width: '100%'
	},

	attachmentGroup: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: 1
	},

	addAttachmentButton: {
		alignSelf: 'flex-start',
		textTransform: 'none',
		fontSize: '0.875rem',
		fontWeight: 500,
		color: 'primary.main',
		backgroundColor: 'transparent',
		'&:hover': {
			backgroundColor: 'transparent'
		},
		'&:hover [data-slot="label"]': {
			textDecoration: 'underline'
		}
	},

	attachmentCount: {
		color: 'text.secondary',
		fontWeight: 400
	},

	actions: {
		display: 'flex',
		gap: 1,
		width: '100%',
		alignItems: 'center',
		justifyContent: 'flex-end'
	},

	submitBtn: {
		'&.Mui-disabled': {
			backgroundColor: 'grey.300',
			opacity: 1
		}
	}
};
